import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API_BASE = `${BACKEND_URL}/api`;

// Create axios instance
const apiClient = axios.create({
  baseURL: API_BASE,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add auth token to requests
apiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Auth API
export const authAPI = {
  register: async (email, username, password) => {
    const response = await apiClient.post('/auth/register', {
      email,
      username,
      password,
    });
    return response.data;
  },

  login: async (email, password) => {
    const response = await apiClient.post('/auth/login', {
      email,
      password,
    });
    return response.data;
  },

  getCurrentUser: async () => {
    const response = await apiClient.get('/auth/me');
    return response.data;
  },
};

// Games API
export const gamesAPI = {
  generateGame: async (prompt, genre, style, difficulty) => {
    const response = await apiClient.post('/games/generate', {
      prompt,
      genre,
      style,
      difficulty,
    });
    return response.data;
  },

  getGenerationStatus: async (sessionId) => {
    const response = await apiClient.get(`/games/generate/status/${sessionId}`);
    return response.data;
  },

  getUserGames: async () => {
    const response = await apiClient.get('/games');
    return response.data;
  },

  getGame: async (gameId) => {
    const response = await apiClient.get(`/games/${gameId}`);
    return response.data;
  },

  getPublicGame: async (gameId) => {
    const response = await axios.get(`${BACKEND_URL}/api/games/public/${gameId}`);
    return response.data;
  },

  remixGame: async (gameId, prompt) => {
    const response = await apiClient.put(`/games/${gameId}/remix`, {
      prompt,
    });
    return response.data;
  },

  deleteGame: async (gameId) => {
    const response = await apiClient.delete(`/games/${gameId}`);
    return response.data;
  },
};

// Monetization API
export const monetizationAPI = {
  trackImpression: async (gameId, adType = 'banner') => {
    const response = await axios.post(
      `${BACKEND_URL}/api/monetization/games/${gameId}/ads/impression`,
      null,
      {
        params: {
          ad_type: adType,
        },
      }
    );
    return response.data;
  },
};

// Assets API
export const assetsAPI = {
  generateSprite: async (prompt, style, gameId) => {
    const response = await apiClient.post('/assets/generate/sprite', {
      prompt,
      style,
      game_id: gameId,
    });
    return response.data;
  },

  generateTileset: async (prompt, style, gameId) => {
    const response = await apiClient.post('/assets/generate/tileset', {
      prompt,
      style,
      game_id: gameId,
    });
    return response.data;
  },

  generateBackground: async (prompt, style, gameId) => {
    const response = await apiClient.post('/assets/generate/background', {
      prompt,
      style,
      game_id: gameId,
    });
    return response.data;
  },

  getAudioLibrary: async () => {
    const response = await apiClient.get('/assets/audio/library');
    return response.data;
  },
};

export default apiClient;
